'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _normalizr = require('normalizr');

var customerSchema = new _normalizr.Schema('customers');

exports.default = customerSchema;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/api/schemas/customerSchema.js
// module id = 1290
// module chunks = 0